module.exports = __webpack_public_path__ + "img/flat_war2.90868c28.jpg";